"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const Basket_1 = require("../../stores/Basket");
const Alerts_1 = require("../../stores/Alerts");
const AlertType_1 = require("../../src/types/AlertType");
exports.default = (0, vue_1.defineComponent)({
    setup(props, ctx) {
        const quantity = (0, vue_1.ref)(1);
        const addedToBasket = (0, vue_1.ref)(false);
        const store = (0, Basket_1.useBasketStore)();
        const alertStore = (0, Alerts_1.useAlertsStore)();
        function addToBasket() {
            store
                .add(props.listingSlug, 'listing', quantity.value)
                .then(() => {
                return store.addExtras();
            })
                .then(() => {
                alertStore.add({
                    type: AlertType_1.AlertType.Success,
                    message: "That's in your basket!",
                    key: 'add-to-basket',
                    url: '/basket',
                });
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                    'event': 'add_to_cart',
                    'product': props.listingSlug
                });
            })
                .catch((err) => {
                var _a, _b;
                let message = 'There was a problem adding that to your basket.';
                if ((_b = (_a = err === null || err === void 0 ? void 0 : err.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.error) {
                    message = err.response.data.error;
                }
                alertStore.add({
                    type: AlertType_1.AlertType.Error,
                    message: message,
                    key: 'add-to-basket',
                });
            });
        }
        return () => (0, vue_1.h)('div', ctx.slots.default({
            quantity: quantity,
            addToBasket: addToBasket,
            addedToBasket: addedToBasket,
        }));
    },
    props: {
        listingSlug: {
            type: String,
            required: true,
        },
        listingType: {
            type: String,
            required: true,
        },
    },
});
